import { render, staticRenderFns } from "./UserSettingsSidebar.vue?vue&type=template&id=eead9660&scoped=true&"
import script from "./UserSettingsSidebar.vue?vue&type=script&lang=js&"
export * from "./UserSettingsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsSidebar.vue?vue&type=style&index=0&id=eead9660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eead9660",
  null
  
)

export default component.exports